export const listTableFields = {
  computed: {
    listTableFields() {
      return [
        {
          label: this.$t("delivery.fields.deliveryNumber"),
          key: 'number',
          tdAttr: {
            style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px',
          },
          thAttr: {
            style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
          },
        },
        // {
        //   TODO change key of the Number of Sales Order if API is available
        //   label: 'No. SO',
        //   key: 'number.so'
        // },
        {
          label: this.$t("global.field.customer"),
          key: 'shipped_customer.name',
        },
        {
          label: 'Status',
          key: 'status.name',
        },
        {
          label: this.$t("global.field.originAddress"),
          key: 'origin_address.name',
        },
        {
          label: this.$t("global.field.destinationAddress"),
          key: 'destination_address.name',
        },
        {
          label: this.$t("global.field.marketingEmployee"),
          key: 'marketing_user.name',
        },
        {
          label: this.$t("global.field.createdDate"),
          key: 'created_on',
        },
        {
          label: this.$t("invoice.fields.totalLoad"),
          key: 'load_count',
        },
        {
          label: this.$t("invoice.fields.loadWeight"),
          key: 'load_weight',
        },
        {
          label: this.$t("invoice.fields.loadVolume"),
          key: 'load_volume',
        },
        // {
        //   TODO change key of the travel cost if API is available
        //   label: 'Biaya Pengiriman',
        //   key: 'travel_cost'
        // }
      ];
    }
  }
}